export enum InscriptionStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  /** Cadastro integral: desafios e cursos concluídos. */
  COMPLETED = "COMPLETED",
}

/** Mirrors API `ParticipantUiPhase` — which global modal to show. */
export enum ParticipantUiPhase {
  NONE = "NONE",
  INSCRIPTION_COMPLETED_CELEBRATION = "INSCRIPTION_COMPLETED_CELEBRATION",
  WAITING_FINALISTS_ANNOUNCEMENT = "WAITING_FINALISTS_ANNOUNCEMENT",
  NOT_CLASSIFIED = "NOT_CLASSIFIED",
}

export type InscriptionStatusResponse = {
  status: InscriptionStatus;
  totalChallenges: number;
  totalCourses: number;
  completedChallengesApproved: number;
  completedCoursesFinished: number;
  /** Submitted at least once (any status). */
  challengesSubmittedCount: number;
  /** Started or finished (not pending). */
  coursesWithStartedProgressCount: number;
  advancedToResultStage: boolean;
  finalistsAnnouncementAt: string | null;
  firstStageClosed: boolean;
  participantUiPhase: ParticipantUiPhase;
};
